module.exports = __webpack_public_path__ + "static/logo.3854ebec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 492
// module chunks = 114276838955818